var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEyeOn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_ionic-md-eye-off",
    "data-name": "Icon ionic-md-eye-off",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-view",
    transform: "translate(0 0.237)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Boundary",
    width: 26,
    height: 26,
    transform: "translate(0 -0.237)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Color",
    "data-name": " \\u21B3Color",
    d: "M11.8,16.1A12.589,12.589,0,0,1,4.586,13.84,12.7,12.7,0,0,1,0,8.048a12.683,12.683,0,0,1,23.609,0,12.7,12.7,0,0,1-4.586,5.791A12.589,12.589,0,0,1,11.8,16.1Zm0-13.415a5.366,5.366,0,1,0,5.366,5.365A5.371,5.371,0,0,0,11.8,2.683Zm0,8.585a3.22,3.22,0,1,1,3.22-3.22A3.223,3.223,0,0,1,11.8,11.269Z",
    transform: "translate(0.438 5.463)",
    fill: "#005288"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOn);
export default __webpack_public_path__ + "static/media/eye-on.f8f8001e8d4d0df5783e8e46be3d85ae.svg";
export { ForwardRef as ReactComponent };